import { Form, Button, Container, Card } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { Input, PasswordInput } from "../../components";
import { useMediaQuery } from "../../context/MediaQueryContext";
import { useTranslation } from "react-i18next";
import { login } from "../../api/user";
import { LocalStorageKey, Pages } from '../../shared/enums'
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { Theme } from "../../shared/theme";

const Login = ({ }) => {
    const form = useForm()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { isSmallScreen } = useMediaQuery();
    const [isLoading, setIsLoading] = useState(true)
    const [isSubmitting, setIsSubmitting] = useState(false)

    useEffect(() => {
        if (!isEmpty(localStorage.getItem(LocalStorageKey.TOKEN))) {
            navigate(Pages.Default)
        }
        setIsLoading(false)
    }, [])

    const onSubmit = async (data) => {
        setIsSubmitting(true)
        const response = await login(data)

        if (response.success) {
            navigate(Pages.Default)
        }
        setIsSubmitting(false)
    }

    return !isLoading && <Container
        fluid
        className="d-flex flex-column align-items-center justify-content-center min-vh-100"
        style={{
            background: Theme.primary,
            padding: "20px",
        }}
    >
        <img alt="logo-text" src="/logo-text.png" />
        <Card className={`${isSmallScreen ? "p-2" : "p-4"} shadow mt-4 mb-5`} style={{ maxWidth: "400px", width: "100%", borderRadius: "10px" }}>
            <Card.Body >
                <h2 className="text-center mb-4">{t("LOGIN")}</h2>
                <FormProvider {...form}>
                    <Form onSubmit={form.handleSubmit(onSubmit)}>
                        <Input label={t("EMAIL")} name={"email"} type="email" rules={{ required: t("EMAIL_IS_REQUIRED") }} />
                        <PasswordInput label={t("PASSWORD")} name={"password"} rules={{ required: t("PASSWORD_IS_REQUIRED") }} />
                        <Button type="submit" variant="primary" className="w-100 mt-3">
                            {t("LOGIN")}
                        </Button>
                    </Form>
                </FormProvider>
            </Card.Body>
        </Card>
    </Container >
};

export default Login;